import { types } from "mobx-state-tree";

export const HomeModel = types.model("HomeModel", {
  fullName: types.string,
  countLeadClients: types.number,
  countLeadCoaches: types.number,
  countClients: types.number,
  countClientsVIP: types.number,
  countBabyCoaches: types.number,
});
